export default [
    {
      path: '/privacy',
      name: 'privacy',
      component: () => import('@/views/sft/Privacy.vue'),
    },
  ]